import React from "react";
import styled, { css } from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import SearchBar from "../../index";
import DropDownAndInput from "../../components/DropDownAndInput";
import SearchButton from "../../components/SearchButton";
import CloseModalButton from "./CloseModalButton";

//styles
import { convertPxToRem } from "frontend/components/helpers";

// Ios Modal Background
// #141824 orca
const BG_DARK = `rgba(20, 24, 36, 0.8)`;
// #FFFFFF snow
const BG_LIGHT = `rgba(255, 255, 255, 0.8)`;

const IOSCanvasStyled = styled.div``;
const SearchBarWrapperStyled = styled.div``;

const HeaderSearchBarStyled = styled.div`
    transition: background-color 0.3s ease;

    ${({ $showIosSearchModal, $isDarkMode }) => {
        if ($showIosSearchModal) {
            return css`
                width: 100%;
                background-color: ${$isDarkMode ? BG_DARK : BG_LIGHT};

                position: fixed;
                z-index: 2000;
                left: 0rem;
                top: 0rem;
                right: 0rem;
                height: 100vh;

                ${IOSCanvasStyled} {
                    width: 100%;
                    height: ${convertPxToRem(250)};

                    display: flex;
                    align-items: flex-end;

                    ${SearchBarWrapperStyled} {
                        width: 100%;
                        padding: ${convertPxToRem(10)} ${convertPxToRem(15)};
                    }
                }
            `;
        }
    }}
`;

// This is the default variation
// all the default styles of the SearchBar reflect the HeaderSearchBar
export const HeaderSearchBar = props => {
    const { id = "header-search" } = props;

    const {
        isDarkMode,
        showIosSearchModal,
        setShowIosSearchModal
    } = useSiteHeader();

    const inputOnFocus = () => {
        setShowIosSearchModal(true);
    };

    return (
        <HeaderSearchBarStyled
            $showIosSearchModal={showIosSearchModal}
            $isDarkMode={isDarkMode}
        >
            <IOSCanvasStyled>
                <SearchBarWrapperStyled>
                    <SearchBar
                        {...props}
                        id={id}
                        isInSiteHeader
                        inputOnFocus={inputOnFocus}
                    >
                        <DropDownAndInput />
                        <SearchButton />
                    </SearchBar>
                </SearchBarWrapperStyled>
                <CloseModalButton />
            </IOSCanvasStyled>
        </HeaderSearchBarStyled>
    );
};

export default HeaderSearchBar;

import PropTypes from "prop-types";

// prop-types
HeaderSearchBar.propTypes = {
    id: PropTypes.string
};
